import Vue from 'vue'
import Vuex from 'vuex'
import store from './store.js'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import VueTelInputVuetify from "vue-tel-input-vuetify"
import Breadcrumbs from './components/Breadcrumbs.vue'
import mixins from './mixins.js'
import VueClipboard from 'vue-clipboard2'
import QrcodeVue from 'qrcode.vue'
// import {handleGlobalError, handleVueError, handleUncaughtRejection} from './components/Utils/ErrorLogger'
import Page from './Base/Page.vue'
import SubTopBar from './Base/SubTopBar'
import DataTable from './components/Utils/DataTable.vue'

if (!Array.prototype.last) {
  Array.prototype.last = function () {
    return this[this.length - 1]
  }
}

const Iam = require('iam')
const defaultClient = Iam.ApiClient.instance
defaultClient.basePath = "/api"
defaultClient.enableCookies = true
Vue.prototype.$api = new Iam.DefaultApi()

Vue.component('Page', Page)
Vue.component('SubTopBar', SubTopBar)
Vue.component('data-table', DataTable)

Vue.use(Breadcrumbs)
Vue.use(VueTelInputVuetify, {
  vuetify,
})
Vue.use(VueClipboard)
Vue.use(QrcodeVue)
Vue.config.productionTip = false
Vue.use(Vuex)
Vue.use(store)

Vue.mixin(mixins)

//if(window.location.hostname != 'iam-dev.gig.tech.local'){
//  window.onerror = handleGlobalError
//  Vue.config.errorHandler = handleVueError
//  window.addEventListener('unhandledrejection', handleUncaughtRejection)
//}

new Vue({
  vuetify,
  store,
  router,
  render: h => h(App)
}).$mount('#app')
